<template>
  <div class="releaseProject">
    <!--  项目发布 -->
    <h1>项目发布</h1>
    <!-- 前台项目发布 -->
    <div class="item">
      <h6>前台项目发布 <a href="https://jpweb.rakumart.cn" target="_blank" style="margin-left: 30px ;"><el-button type="primary"
            size="mini">查看</el-button></a> </h6>
      <el-upload class="upload-demo" drag action="https://jpapi.rakumart.cn/api/publish.publishClientPC" multiple
        name="file" :on-success="handleAvatarSuccess">
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
      </el-upload>
    </div>
    <!-- 后台项目发布 -->
    <div class="item">
      <h6>后台项目发布 <a href="https://jpmanage.rakumart.cn" target="_blank" style="margin-left: 30px ;"><el-button
            type="primary" size="mini">查看</el-button></a> </h6>
      <el-upload class="upload-demo" drag action="https://jpapi.rakumart.cn/api/publish.publishAdminPC" multiple
        name="file" :on-success="handleAvatarSuccess">
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
      </el-upload>
    </div>
    <!-- 前台项目H5 -->
    <div class="item">
      <h6>前台项目H5发布 <a href="https://jpweb.rakumart.cn" target="_blank" style="margin-left: 30px ;"><el-button
            type="primary" size="mini">查看</el-button></a> </h6>
      <el-upload class="upload-demo" drag action="https://jpapi.rakumart.cn/api/publish.publishClientH5" multiple
        name="file" :on-success="handleAvatarSuccess">
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
      </el-upload>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {

    };
  },
  methods: {
    handleAvatarSuccess(file) {
      this.$message.success(file.msg);
    },
  }
}
</script>
<style lang='scss' scoped>
.releaseProject {
  margin: 60px;
  background-color: #f6f6f6;
  padding: 60px;
  border-radius: 10px;

  h1 {
    font-size: 40px;
    margin-bottom: 30px;
  }

  .item {
    margin-bottom: 50px;

    h6 {
      font-size: 20px;
      margin: 20px 0;
    }
  }
}
</style>